module.exports = "<ngb-pagination\n  *ngIf=\"pageInfo\"\n  [collectionSize]=\"pageInfo.pageCount * pageInfo.pageSize\"\n  [pageSize]=\"pageInfo.pageSize\"\n  [(page)]=\"pageInfo.pageNumber\"\n  [maxSize]=\"5\"\n  [boundaryLinks]=\"true\"\n  (pageChange)=\"pageChange($event)\"></ngb-pagination>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/atoms/pagination/pagination.component.html
// module id = ./src/app/shared/atoms/pagination/pagination.component.html
// module chunks = main